import { render, staticRenderFns } from "./IconSelectorDialog.vue?vue&type=template&id=d3023930&scoped=true&"
import script from "./IconSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./IconSelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3023930",
  null
  
)

export default component.exports